import React from 'react';
import { Menu } from 'lucide-react';
import { useLanguage } from './LanguageContext';
import LanguageToggle from './LanguageToggle';

/**
 * The 56px sticky bar that replaces the sidebar header on a phone. The
 * language toggle lives here because the sidebar footer that normally holds
 * it is off screen, and a Thai user must not lose the switch.
 */
const MobileHeader = ({ title, onOpenDrawer, user }) => {
  const { print_lang } = useLanguage();

  return (
    <header className="mobile-header">
      <button
        type="button"
        className="mobile-header-menu"
        onClick={onOpenDrawer}
        aria-label={print_lang('menu', 'Menu')}
      >
        <Menu className="w-5 h-5" aria-hidden="true" />
      </button>

      <h1 className="mobile-header-title">{title}</h1>

      <div className="mobile-header-right">
        <LanguageToggle />
        <div className="mobile-header-avatar">
          {user?.name?.charAt(0).toUpperCase() || 'D'}
        </div>
      </div>
    </header>
  );
};

export default MobileHeader;
